<!--
 * @Description: 交叉分析
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2020-01-02 15:58:49
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-06-15 16:36:07
-->
<template>
  <div id="crossAnalysis" class="public-content public-full-container">
    <el-row class='crossAnalysis_header'>
      <el-col :span='2'>
        <span class='labels'><img src="/static/icon/jxfx_icon.png" alt="">交叉分析</span>
      </el-col>
      <el-col :span='17'>
        <div>
          <div class='userChangeStyle'>
            <el-input placeholder="所有账户" v-model="userNameShow" style='width:180px;margin:0 20px 0 0px;' size='mini'
              readonly>
              <!-- <el-button slot="append" icon="el-icon-arrow-down"></el-button> -->
            </el-input>
            <user-account class='isDialogShow' @arrayChangeSend='arrayChangeSend' @sendList='sendList'></user-account>
          </div>
          <el-date-picker v-model="dateList" type="monthrange" range-separator="至" size='mini'
            @change='handleDateChange' style="width:260px" format="yyyy年MM期" start-placeholder="开始月份"
            end-placeholder="结束月份">
          </el-date-picker>
          <el-checkbox @change="handleCheck" v-model='form.statisticsInside' style='padding-left: 20px;'>统计内部转账
          </el-checkbox>
          <el-checkbox @change="handleCheck" v-model='form.displayZero'>不显示为0的数</el-checkbox>
        </div>
      </el-col>
      <el-col :span='5' style='text-align: right;'>
        <el-button size='mini' @click="superReqTable">刷新</el-button>
        <el-button size='mini' v-for='i in buttonList' :key='i.id' @click='importTable'>{{i.name}}</el-button>
      </el-col>
    </el-row>

    <el-row class='baobiaoChose'>
      <!--   <span class='labels'>选择表报</span> -->
      <div class='baobiaoChose_list'>
        <draggable v-model='baobiaoList' style='display: inline-block;' @change='handleChangeDrag'>
          <span class='item_list' v-for='i in baobiaoList' :key='i.id' @click='handleClickTab(i)'
            :class='form.analysisReportFormId===i.id?"active_bb":""'>{{i.name}}

            <el-popover placement="bottom" width="50" class='handleDDD' trigger="hover"
              v-if='i.buttons.length&&(form.analysisReportFormId===i.id)&&i.id!=="193520"'>
              <span v-for='j in i.buttons' :key='j.name' class='BBButton'
                @click='handleOperationBB(j,i)'>{{j.name}}</span>
              <i class='el-icon-more ' slot="reference"></i>
            </el-popover>

          </span>
        </draggable>
        <span class='item_list item_lists' @click.stop='handleClickTab({})'
          v-if="(newTabId !== '193520') || !baobiaoList.length">
          <i class='el-icon-circle-plus-outline'></i>
          新增报表
        </span>
      </div>
    </el-row>
    <!-- 表格容器 -->
    <div class='tableView' :class='isFullScreen?"fullScreenStyle":""' @keyup.esc='escClick'>
      <div class='table_title'>
        <div class="table_title-dataRange">资料区间：{{tableHeaderData.dateRange}}</div>
        <div class='table_title-title'>{{tableHeaderData.title}}</div>
        <div class='fullScreen' @click='handleFullScreen' v-if='!isFullScreen'>
          <img src="/static/icon/fullScreen.png" alt=""
            style='display: inline-block;margin-right: 5px;vertical-align: top;margin-top: 2px;'>
          全屏查看
        </div>
        <div class='fullScreen' @click='handleFullScreenBack' v-else>
          <img src="/static/icon/backFullScreen.png" alt=""
            style='display: inline-block;margin-right: 5px;vertical-align: top;margin-top: 2px;'>
          退出全屏
        </div>
      </div>
      <el-row class='tip_s'>
        <el-col :span='isFullScreen?12:0'>
          <div class='chaeckUserChangeMessage' v-show='isFullScreen'>
            <div style='display: inline-block;'>
              查看统计账户 <i class='el-icon-view'></i>
            </div>
            <user-accountc class='isDialogShow_c' :userList='userList' :dataListArray='dataListArray'></user-accountc>
          </div>

        </el-col>
      </el-row>
      <div class='table_r' ref='tableView' v-loading='tableLoading'
        :style="{ width:drawer?'calc(100% - 4.24rem)':'100%' }" v-show="tableInnerHTML">

      </div>
      <div v-show="!tableInnerHTML" class="table_d">
        暂无数据
      </div>
      <!-- 拖动值场所 -->
      <setting-field :holdData="holdData" ref="settingField" :tabId='newTabId' @fieldShowChange="fieldShowChange"
        @previewTableData="fastShow">
      </setting-field>
    </div>

    <!-- 抽屉组件 -->
    <!-- <cross-analysis-dialog
        :drawer.sync='drawer'
        :formData='form'
        @successSave='successSave'
        :newTabId='newTabId'
        @fastShow='fastShow'
        @deleteItem='deleteItem'
        :newTabName='newTabName'>
    </cross-analysis-dialog> -->
    <add-crossAnalysis :drawer.sync='drawer' :formData='form' @itemHold="getHoldMessage" @deleteItem='deleteItem'
      @openSetting="openSetting" @saveReportForm="saveReportForm" :tabName="newTabName" ref="addCrossAnalysisRef">
    </add-crossAnalysis>
  </div>


</template>

<script>
import settingField from "./components/crossAnalysis/settingField"
import addCrossAnalysis from "./components/crossAnalysis/add-crossAnalysis"
import crossAnalysisDialog from '@/components/dialog/crossAnalysisDialog'
import userAccount from "./components/userAccount"
import userAccountc from "./components/userAccountc"
import draggable from 'vuedraggable'
import $ from 'jquery'
export default {
  components: {
    crossAnalysisDialog,
    draggable,
    userAccount,
    userAccountc,
    addCrossAnalysis,
    settingField
  },
  data() {
    return {
      nowFastReqData: {},  // 当前快速请求数据
      isTableShow: true,  // 冲渲染表格
      holdData: {},  // 当前鼠标点击的项信息
      dataListArray: {},   // 选中集合
      userNameShow: "",//所有账户显示
      tableLoading: false,
      isFullScreen: false,  // 是否全屏
      tableHeaderData: {   // 表头数据
        title: "",
        type: "",
        dateRange: ""
      },
      tableInnerHTML: "", // 表格数据
      userList: {}, // 所有用户
      form: {
        journalAccountIds: [],  // 用户ID
        analysisReportFormId: "", // 报表ID
        startYearPeriods: "", // 开始
        endYearPeriods: "", // 结束
        displayZero: false,       // 是否显示为0的数
        statisticsInside: false,  // 是否显示内部转账
      },
      drawer: false, // 是否打开抽屉
      newTabId: "",          // 当前点击ID
      newTabName: "",          // 当前点击name
      baobiaoList: [],
      dateList: [new Date(), new Date()],       // 会计期间
      buttonList: [],  // 导出
      tableColumn: 1,
    }
  },
  created() {
    this.form.startYearPeriods = this.$util.formatDate.format(this.dateList[0], 'yyyyMM');
    this.form.endYearPeriods = this.$util.formatDate.format(this.dateList[1], 'yyyyMM');
    this.tableHeaderData.dateRange = this.$util.formatDate.format(this.dateList[0], 'yyyy年MM期') + " - " + this.$util.formatDate.format(this.dateList[1], 'yyyy年MM期')
    //this.getUserInfo();
    this.getBBlist();
    this.getImportButton();

  },

  mounted() {
    let _ = this;
    this.$nextTick(() => {
      document.addEventListener('keyup', (e) => {
        if (e.keyCode === 27) {
          _.isFullScreen = false;
        }
      })



    })
  },

  computed: {

  },
  watch: {
    newTabId(val) {
      if (val === "193520") {
        this.tableInnerHTML = "";
        this.$refs.addCrossAnalysisRef.clearData();
      }
    },
    drawer(val, oldVal) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.nowFastReqData.status) {
            this.renderTable();
          } else {
            this.superReqTable();
          }
        }, 510)
      })
      if (!val) {  // 配置侧弹框关闭后一定关闭区域
        this.$refs.settingField.isSettingFieldShow = false;
      }
    }
  },
  activated() {

  },
  methods: {
    /**
     * @description: 赋值显示状态
     * @param {*} val
     * @return {*}
     * @author: jinchuan.lee
     */
    fieldShowChange(val) {
      this.$refs.addCrossAnalysisRef.isOpenSetting = val;
    },
    /**
     * @description: 根据当前报表类型请求表格
     * @param {*}
     * @return {*}
     * @author: jinchuan.lee
     */
    superReqTable() {
      if (this.form.analysisReportFormId == "193520" && this.nowFastReqData.status) {
        this.getTableInnerHTML(this.nowFastReqData.data);
      } else {
        this.getTableInnerHTML();
      }
    },
    /**
     * @description: 保存报表
     * @param {Object} data 报表基本信息
     * @return {*}
     * @author: jinchuan.lee
     */
    saveReportForm(data) {
      data.id = this.newTabId === "193520" ? "" : this.newTabId;
      let allData = this.$refs.settingField.getRequestData();
      let params = {
        name: data.name,
        id: data.id,
        ...allData.data
      }
      this.$http.post('analysis/save', params).then(res => {
        if (res && res.data.code == 1) {
          this.$refs.addCrossAnalysisRef.isDialogShow = false;
          this.$refs.addCrossAnalysisRef.clearData();
          // 清空拖动域里面的值
          this.$refs.settingField.clearData();
          // 请求表格
          this.getBBlist(this.newTabId, true);
        }
      })
    },
    /**
     * @description: 打开配置框
     * @param {*}
     * @return {*}
     * @author: jinchuan.lee
     */
    openSetting(val) {
      this.$refs.settingField.isStop = val;
      this.$refs.settingField.isSettingFieldShow = val;
    },
    // 获取鼠标点击的item的信息
    getHoldMessage(data) {
      this.holdData = data;
    },
    // 显示为零的数
    handleCheck() {
      this.superReqTable();
    },
    // 接收所有用户
    sendList(data) {
      this.userList = data;
    },
    // 用户选择改变
    arrayChangeSend(data) {
      this.form.journalAccountIds = data.bankUserList.concat(data.cashUserList);
      this.dataListArray = data;
      this.form.journalAccountIds = Array.from(new Set(this.form.journalAccountIds));
      this.userNameShow = this.form.journalAccountIds.length ? `您已选择${this.form.journalAccountIds.length}个账户` : "";
      this.superReqTable();
    },
    // 报表拖动
    handleChangeDrag(val) {
      // let nowItemIndex = val.moved.newIndex,dragFront,dragAfter;
      // if(nowItemIndex===0) {
      //     dragFront = this.baobiaoList[nowItemIndex].id;
      //     dragAfter = this.baobiaoList[nowItemIndex+1].id;
      // }else if(nowItemIndex === this.baobiaoList.length-1) {
      //     dragAfter = this.baobiaoList[nowItemIndex].id;
      //     dragFront = this.baobiaoList[nowItemIndex-1].id;
      // }else {
      //     dragAfter = this.baobiaoList[nowItemIndex+1].id;
      //     dragFront = this.baobiaoList[nowItemIndex-1].id;
      // }
      this.$http.post('analysis/dragAnalysisReportForm', { analysisReportForms: this.baobiaoList }).then(res => {
        if (res && res.data.code == 1) {
          this.$message.success(res.data.msg)
        }
      })
    },
    // 实时请求
    fastShow(Obj) {
      this.nowFastReqData = Obj;
      this.getTableInnerHTML(Obj.data);
    },
    // 删除未命名
    deleteItem(data) {
      if (data) {
        // 清空拖动域里面的值
        this.$refs.settingField.clearData();
        // 切换如果有临时添加，将其删除
        let data = this.baobiaoList.find(i => { return i.id === "193520" })
        if (data) {
          this.baobiaoList.splice(-1, 1);
          if (this.baobiaoList.length) {
            console.log(this.newTabId)
            this.form.analysisReportFormId = this.baobiaoList[this.baobiaoList.length - 1].id;
            this.tableHeaderData.title = this.baobiaoList[this.baobiaoList.length - 1].name;
            this.newTabId = this.form.analysisReportFormId;
            this.nowFastReqData = {};  // 清空缓存
            // this.getTableInnerHTML();
          } else {
            this.$refs.tableView.innerHTML = "";
          }
        } else {
          this.nowFastReqData.status = true;
        }
      }
    },
    // 导出
    importTable() {
      let params = {
        cid: sessionStorage.cid,
        token: sessionStorage.token,
        ...this.form,
      }
      params.displayZero = params.displayZero ? 1 : 0;
      const router = this.$router.resolve({
        path: '/export/crossAnalysis',
        query: params
      })

      window.location.href = this.$rootUrl + router.href;
    },
    // 获取导出按钮
    getImportButton() {
      this.$http.post('sys/menu/findPermissionMenu', { permissions: "cashier:analysis:export" }).then(res => {
        if (res && res.data.code == 1) {
          this.buttonList = res.data.data;
        }
      })
    },
    // esc时间
    escClick(e) {
      console.log(e)
    },
    // 点击全屏
    handleFullScreen() {
      if (!this.$refs.tableView.innerHTML || this.$refs.tableView.innerHTML === "") {
        return this.$message.warning('未检测到表格数据!')
      }
      this.isFullScreen = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.renderTable();
        }, 510)
      })
    },
    // 退出全屏
    handleFullScreenBack() {
      this.isFullScreen = false;
      this.$nextTick(() => {
        setTimeout(() => {
          this.renderTable();
        }, 510)
      })
    },
    // 日期改变
    handleDateChange(val) {
      this.form.startYearPeriods = this.$util.formatDate.format(val[0], 'yyyyMM');
      this.form.endYearPeriods = this.$util.formatDate.format(val[1], 'yyyyMM');
      this.tableHeaderData.dateRange = this.$util.formatDate.format(val[0], 'yyyy年MM期') + " - " + this.$util.formatDate.format(val[1], 'yyyy年MM期')
      this.superReqTable();
    },
    // 账户改变
    // handleZHchange(val) {
    //   this.form.fkJournalAccountId = val;
    //   let data = this.userList.find(i=>{return i.id===val});
    //   this.tableHeaderData.type = data.name;
    //   this.getTableInnerHTML();
    // },
    // 报表操作
    handleOperationBB(j, i) {
      // 切换如果有临时添加，将其删除
      let data = this.baobiaoList.find(i => { return i.id === "193520" });
      if (data) {
        this.baobiaoList.splice(-1, 1);
        this.form.analysisReportFormId = i.id;
        this.tableHeaderData.title = i.name
        this.getTableInnerHTML();
      }
      if (j.name === "修改配置") {
        this.newTabId = i.id;
        this.newTabName = i.name;
        this.drawer = true;
        this.$refs.settingField.setData(i.id);
      } else if (j.name === "删除") {
        this.$confirm(`即将删除  ${i.name}， 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$http.post('analysis/deleteAnalysisReportForm', { id: i.id }).then(res => {
            if (res && res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.form.analysisReportFormId = "";
              this.tableHeaderData.title = "";
              this.newTabName = "";
              this.getBBlist();
            }
          })

        }).catch(() => {

        });
      }
    },
    // 保存成功
    successSave(data) {
      if (data) {
        this.getBBlist(data);
      }
    },
    // tab点击
    handleClickTab(row) {
      this.$refs.settingField.isStop = false;  // 默认自动关闭
      if (this.drawer) {
        return this.$message.warning("请先关闭当前编辑！")
      }
      if (this.newTabId === "193520" && row.id === "193520") {
        this.drawer = true;
        this.newTabId = "193520";
        return;
      }
      if (row.id) {
        if (this.newTabId === "193520") {  // 如果有临时报表  需要提示  否则直接切换
          this.$confirm('检测到当前有临时配置，是否放弃?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.newTabId = row.id;
            this.newTabName = row.name;
            this.form.analysisReportFormId = row.id;
            this.tableHeaderData.title = row.name;
            if (!this.drawer) {
              this.getTableInnerHTML();
            }
            // 切换如果有临时添加，将其删除
            let data = this.baobiaoList.find(i => { return i.id === "193520" })
            if (data) {
              this.baobiaoList.splice(-1, 1);
            }
            this.drawer = false;
          })
        } else {
          this.newTabId = row.id;
          this.newTabName = row.name;
          this.form.analysisReportFormId = row.id;
          this.tableHeaderData.title = row.name;
          // 切换如果有临时添加，将其删除
          let data = this.baobiaoList.find(i => { return i.id === "193520" })
          if (data) {
            this.baobiaoList.splice(-1, 1);
          }
          if (!this.drawer) {
            this.getTableInnerHTML();
          }
          this.drawer = false;
        }

      } else {
        this.$refs.settingField.clearData();
        this.newTabName = "";
        this.tableHeaderData.title = "未命名";

        let data = this.baobiaoList.find(i => { return i.id === "193520" })
        if (!data) {
          this.baobiaoList.push({
            name: '未命名',
            id: "193520",
            buttons: []
          })
          this.newTabId = "193520";
          this.$refs.tableView.innerHTML = "";
        }
        this.form.analysisReportFormId = '193520';
        this.drawer = true;
        this.$refs.settingField.isSettingFieldShow = true;
        this.$refs.settingField.isStop = true;

      }


    },
    // 获取所有账户
    // getUserInfo() {
    //   this.$http.post('journal/findAccount',{type:'3'}).then(res=>{
    //       if(res&&res.data.code==1) {
    //         this.userList = res.data.data;
    //         if(this.userList.length) {
    //           this.form.fkJournalAccountId = this.userList[0].id;
    //           this.tableHeaderData.type = this.userList[0].name;
    //         }
    //       }
    //   })
    // },
    // 获取报表 status为ture时不请求表格
    getBBlist(type, status) {
      this.$http.post('analysis/findAnalysisReportForm', {}).then(res => {
        if (res && res.data.code == 1) {
          this.baobiaoList = res.data.data;
          if (this.baobiaoList.length) {
            if (!type) {
              this.form.analysisReportFormId = this.form.analysisReportFormId ? this.form.analysisReportFormId : this.baobiaoList[0].id;
              this.tableHeaderData.title = this.tableHeaderData.title ? this.tableHeaderData.title : this.baobiaoList[0].name
              this.newTabName = this.newTabName ? this.newTabName : this.baobiaoList[0].name;
            } else if (type === "193520") {
              this.form.analysisReportFormId = this.baobiaoList[this.baobiaoList.length - 1].id;
              this.tableHeaderData.title = this.baobiaoList[this.baobiaoList.length - 1].name;
              this.newTabName = this.baobiaoList[this.baobiaoList.length - 1].name;
              this.newTabId = this.form.analysisReportFormId;

            }
            // 列数赋值
            if (this.baobiaoList.length) {
              this.baobiaoList.forEach(i => {
                if (i.id === this.form.analysisReportFormId) {
                  this.tableColumn = i.row;
                }
              })
            } else {
              this.tableColumn = 1;
            }
            if (!status) {
              this.getTableInnerHTML();
            }
          }
        }
      })
    },
    //  获取表格文本
    getTableInnerHTML(data) {

      let params = {};

      if (!data) {
        if (this.form.analysisReportFormId === "193520") {
          return
        }
        params = {
          ...this.form
        }
      } else {
        params = {
          ...this.form,
          ...data,
        }
      }

      if (!this.form.analysisReportFormId) {
        return this.$message.warning('请选择报表!')
      }

      this.tableLoading = true;
      this.$refs.tableView.innerHTML = "";
      params.displayZero = params.displayZero ? 1 : 0;
      this.$http.post('analysis/findCrossAnalysis', params).then(res => {
        if (res && res.data.code == 1) {
          this.tableInnerHTML = res.data.data ? decodeURIComponent(res.data.data) : "";
          this.$nextTick(() => {
            this.renderTable();
          })
          this.nowFastReqData.status = true;  // 赋值之后马上缓存
        } else {
          this.tableLoading = false;
          this.$refs.tableView.innerHTML = ''
        }

      })
    },
    renderTable() {
      //解码赋值
      this.$refs.tableView.innerHTML = this.tableInnerHTML;
      // over
      if (this.tableInnerHTML) {
        this.initTable();
      }
    },
    // 初始化固定表格
    initTable() {
      try {
        let _ = this;
        setTimeout(() => {
          $("#reportTable_tableLayout").remove()
          this.$refs.tableView.innerHTML = this.tableInnerHTML;
          // 添加hover
          var tableObj = document.getElementsByClassName("dataframe");
          var table = document.getElementsByClassName("dataframe")[0];
          if (!table) return;
          var tr = table.getElementsByTagName("tr");
          var td = table.getElementsByTagName("td");
          var th = table.getElementsByTagName("th");
          for (var i = 0; i < td.length; i++) {
            td[i].onmouseleave = function () {
              for (var j = 0; j < td.length; j++) {
                td[j].className = '';//去除原来影响
                td[j].parentNode.className = '';
              }
              for (var j = 0; j < th.length; j++) {
                if (th[j]) {
                  th[j].className = '';//去除原来影响
                }
              }

            };
            td[i].onmouseenter = function () {
              this.className = 'over';
              this.parentNode.className = 'over';
              var column = this.cellIndex;
              for (var k = 0; k < tr.length; k++) {
                if (tr[k].getElementsByTagName("td").length) {
                  tr[k].getElementsByTagName("td")[column - this.parentNode.getElementsByTagName('th').length].className = 'over';
                } else if (tr[k].getElementsByTagName("th")[column]) {
                  if ((tr[k + 1].getElementsByTagName("td") && tr[k + 1].getElementsByTagName("td").length) || (tr[k + 2].getElementsByTagName("td") && tr[k + 2].getElementsByTagName("td").length)) {
                    tr[k].getElementsByTagName("th")[column].className = 'over';
                  }
                }
              }
            }
          }
          //===========================结束
          var tables = $(".dataframe");
          tables[0].style.minWidth = _.$refs.tableView.clientWidth - 17 + "px";
          var trList_h = tables[0].getElementsByTagName('thead')[0].getElementsByTagName('tr');
          var trList_b = tables[0].getElementsByTagName('tbody')[0].getElementsByTagName('tr')[0].getElementsByTagName('th');

          tables[0].setAttribute('id', 'reportTable');
          var tableId = tables.attr('id');
          var freezeRowNum = trList_h.length;
          var freezeColumnNum = trList_b.length;
          if (typeof (freezeRowNum) != 'undefined' || typeof (freezeColumnNum) != 'undefined') {
            this.$nextTick(() => {
              _.freezeTable(tables, freezeRowNum || 0, freezeColumnNum || 0, _.pageWidth(), _.pageHeight());
            })
            var flag = false;
            $(window).resize(function () {
              if (flag) return;
              setTimeout(function () {
                _.adjustTableSize(tableId, _.pageWidth(), _.pageHeight());
                flag = false;
              }, 100);
              flag = true;
            });
          }

        }, 100)
      } catch (e) {
        // statements
        this.tableLoading = false;
        console.log(e);
      }



    },
    // 重构表格函数
    /*
   * 锁定表头和列
   *
   * 参数定义
   *   table - 要锁定的表格元素或者表格ID
   *   freezeRowNum - 要锁定的前几行行数，如果行不锁定，则设置为0
   *   freezeColumnNum - 要锁定的前几列列数，如果列不锁定，则设置为0
   *   width - 表格的滚动区域宽度
   *   height - 表格的滚动区域高度
   */
    freezeTable(table, freezeRowNum, freezeColumnNum, width, height) {
      try {
        if (typeof (freezeRowNum) == 'string') {
          freezeRowNum = parseInt(freezeRowNum)
        }
        if (typeof (freezeColumnNum) == 'string') {
          freezeColumnNum = parseInt(freezeColumnNum)
        }

        var tableId;
        if (typeof (table) == 'string') {
          tableId = table;
          table = $('#' + tableId);
        } else tableId = table.attr('id');
        var divTableLayout = $("#" + tableId + "_tableLayout");
        if (divTableLayout.length != 0) {
          divTableLayout.before(table);
          divTableLayout.empty();
        } else {

          table.after("<div id='" + tableId + "_tableLayout' style='overflow:hidden;max-height:" + height + "px; width:" + width + "px;'></div>");
          divTableLayout = $("#" + tableId + "_tableLayout");
        }
        var html = '';
        if (freezeRowNum > 0 && freezeColumnNum > 0) html += '<div id="' + tableId + '_tableFix" style="padding: 0px;"></div>';
        if (freezeRowNum > 0) html += '<div id="' + tableId + '_tableHead" style="padding: 0px;"></div>';
        if (freezeColumnNum > 0) html += '<div id="' + tableId + '_tableColumn" style="padding: 0px;"></div>';
        html += '<div id="' + tableId + '_tableData" style="padding: 0px;"></div>';
        $(html).appendTo("#" + tableId + "_tableLayout");
        var divTableFix = freezeRowNum > 0 && freezeColumnNum > 0 ? $("#" + tableId + "_tableFix") : null;
        var divTableHead = freezeRowNum > 0 ? $("#" + tableId + "_tableHead") : null;
        var divTableColumn = freezeColumnNum > 0 ? $("#" + tableId + "_tableColumn") : null;
        var divTableData = $("#" + tableId + "_tableData");
        divTableData.append(table);
        if (divTableFix != null) {
          var tableFixClone = table.clone(true);
          tableFixClone.attr("id", tableId + "_tableFixClone");
          divTableFix.append(tableFixClone);
        }
        if (divTableHead != null) {
          var tableHeadClone = table.clone(true);
          tableHeadClone.attr("id", tableId + "_tableHeadClone");
          divTableHead.append(tableHeadClone);
        }
        if (divTableColumn != null) {
          var tableColumnClone = table.clone(true);
          tableColumnClone.attr("id", tableId + "_tableColumnClone");
          divTableColumn.append(tableColumnClone);
        }
        $("#" + tableId + "_tableLayout table").css("margin", "0");
        if (freezeRowNum > 0) {
          var HeadHeight = 0;
          var ignoreRowNum = 0;
          var ccc = 1000;
          $("#" + tableId + "_tableHead tr:lt(" + freezeRowNum + ")").each(function () {
            if (ignoreRowNum > 0) ignoreRowNum--;
            else {
              var td = $(this).find('td:first, th:first');
              HeadHeight += td.outerHeight(true);
              ignoreRowNum = td.attr('rowSpan');
              if (typeof (ignoreRowNum) == 'undefined') ignoreRowNum = 0;
              else ignoreRowNum = parseInt(ignoreRowNum) - 1;
            }
            ccc -= 2
          });
          HeadHeight *= (ccc / 1000);
          divTableHead.css("max-height", HeadHeight);
          divTableFix != null && divTableFix.css("max-height", HeadHeight);
        }
        if (freezeColumnNum > 0) {
          var ColumnsWidth = 0;
          var ColumnsNumber = 0;
          var cc = 1000;
          $("#" + tableId + "_tableColumn tr:eq(" + freezeRowNum + ")").find("td:lt(" + freezeColumnNum + "), th:lt(" + freezeColumnNum + ")").each(function () {
            if (ColumnsNumber >= freezeColumnNum) return;
            ColumnsWidth += $(this).outerWidth(true);
            ColumnsNumber += $(this).attr('colSpan') ? parseInt($(this).attr('colSpan')) : 1;
            cc -= 1.3;
          });
          ColumnsWidth *= (cc / 1000);
          divTableColumn.css("width", ColumnsWidth);





          //======================================================================================
          divTableFix != null && divTableFix.css("width", ColumnsWidth);
        }
        //==============  
        divTableData.scroll(function () {
          divTableHead != null && divTableHead.scrollLeft(divTableData.scrollLeft());
          divTableColumn != null && divTableColumn.scrollTop(divTableData.scrollTop());
        });
        divTableFix != null && divTableFix.css({
          "overflow": "hidden",
          "position": "absolute",
          "z-index": "50"
        });
        // 判断当前操作系统
        // var agent = navigator.userAgent.toLowerCase();
        //  var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
        //  if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
        //    alert("这是windows32位系统");
        //    }
        //  if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
        //    alert("这是windows64位系统");
        //  }
        //  if(isMac){
        //    alert("这是mac系统");
        //  }
        // over
        divTableHead != null && divTableHead.css({
          "overflow": "hidden",
          "width": width - 10,
          "position": "absolute",
          "z-index": "45"
        });
        divTableColumn != null && divTableColumn.css({
          "overflow": "hidden",
          "max-height": height-10,
          "position": "absolute",
          "z-index": "40"
        });

        divTableData.css({
          "overflow": "auto",
          "width": width,
          "max-height": height,
          "position": "absolute"
        });

        //=======over
        divTableFix != null && divTableFix.offset(divTableLayout.offset());
        divTableHead != null && divTableHead.offset(divTableLayout.offset());
        divTableColumn != null && divTableColumn.offset(divTableLayout.offset());
        divTableData.offset(divTableLayout.offset());
        this.tableLoading = false;
      } catch (e) {
        this.tableLoading = false;
      }
    },
    /*
   * 调整锁定表的宽度和高度，这个函数在resize事件中调用
   *
   * 参数定义
   *   table - 要锁定的表格元素或者表格ID
   *   width - 表格的滚动区域宽度
   *   height - 表格的滚动区域高度
   */
    adjustTableSize(table, width, height) {
      var tableId;
      if (typeof (table) == 'string') tableId = table;
      else tableId = table.attr('id');
      $("#" + tableId + "_tableLayout").width(width).height(height-5);
      $("#" + tableId + "_tableHead").width(width - 10);
      $("#" + tableId + "_tableColumn").height(height);
      $("#" + tableId + "_tableData").width(width).height(height);
    },
    pageHeight() {
      let tableObj = document.getElementsByClassName("table_r")[0];
      return tableObj.clientHeight;
    },
    //返回当前页面宽度
    pageWidth() {
      return this.$refs.tableView.clientWidth;
    },


  },
}
</script>

<style lang="less">
.BBButton {
  display: block;
  padding: 6px 8px;
  cursor: pointer;

  &:hover {
    opacity: .5;
  }

  ;

}

.el-popover {
  min-width: 100px;
}

#crossAnalysis {
  .el-loading-mask {
    z-index: 1300 !important;
  }

  .userChangeStyle {
    position: relative;
    display: inline-block;

    .isDialogShow {
      display: none;
    }

    &:hover {
      .isDialogShow {
        display: block;
      }
    }
  }

  /* 原表格样式控制 */
  #reportTable {}

  /*表格样式*/
  #reportTable_tableHead {
    background-color: #deefea;
  }

  #reportTable_tableHead td {
    border: 1px solid #86afa3;
  }

  #reportTable_tableColumn #reportTable_tableColumnClone th {
    border: 1px solid #86afa3;
  }

  #reportTable_tableColumn #reportTable_tableColumnClone td {
    border: 1px solid #86afa3;
  }

  #reportTable_tableColumn #reportTable_tableColumnClone {
    border-spacing: 0;
    /*表格设置合并边框模型*/
    border-collapse: collapse;
    text-align: center;
  }

  #reportTable_tableHeadClone {
    border-spacing: 0;
    /*表格设置合并边框模型*/
    border-collapse: collapse;
    text-align: center;
  }

  #reportTable_tableHead th {
    border: 1px solid #86afa3;
    color: #333;
  }

  #reportTable_tableColumn {
    background-color: #deefea;
    /*border-right: 1px solid #86afa3;*/
  }

  #reportTable_tableData {
    background-color: #fff;

  }

  /*导航条样式*/
  #reportTable_tableData::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }

  #reportTable_tableData::-webkit-scrollbar-thumb {
    /**滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #999;
  }

  #reportTable_tableData::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #EDEDED;
  }


  /*导航结束========================================*/

  #reportTable_tableFix {
    background-color: #deefea;
    /*border-right: 1px solid #86afa3;*/
  }

  #reportTable_tableData #reportTable td {
    border: 1px solid #e8eaec;
  }

  #reportTable_tableData #reportTable th {
    border: 1px solid #D9D9D9;
  }

  #reportTable_tableData #reportTable {
    border-spacing: 0;
    /*表格设置合并边框模型*/
    border-collapse: collapse;
    text-align: center;
  }

  #reportTable_tableFix #reportTable_tableFixClone {
    border-spacing: 0;
    /*表格设置合并边框模型*/
    border-collapse: collapse;
    text-align: center;

  }

  #reportTable_tableFix #reportTable_tableFixClone td {
    border: 1px solid #86afa3;
  }

  #reportTable_tableFix #reportTable_tableFixClone th {
    border: 1px solid #86afa3;
  }

  /*表格样式结束============*/
  position: relative;

  .labels {
    font-size: .18rem;
    font-weight: 600;
    display: block;

    img {
      margin-right: .15rem;
    }
  }

  .baobiaoChose {
    user-select: none;
    margin-top: 5px;

    .baobiaoChose_list {
      margin-top: 10px;

      .item_list {
        display: inline-block;
        padding: 2px 10px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        margin-right: 20px;
        margin-bottom: 15px;
        color: #4A4A4A;
        font-size: .14rem;
      }

      .active_bb {
        background-color: #269D7B;
        color: #fff;
        border: 1px solid #269D7B;

        .handleDDD {
          display: inline-block;
        }
      }

      .item_lists {
        background-color: #fff;
        border: 1px dashed rgba(233, 233, 233, 1);
        color: #4A4A4A;

        &:hover {
          border: 1px solid rgba(233, 233, 233, 1);
        }

        ;
      }
    }
  }

  .tableView {
    width: 100%;
    background-color: #FCFCFC;
    padding: 10px;
    height: calc(100% - 80px);
    box-sizing: border-box;
    position: relative;
    transition: all .5s;

    .table_title {
      position: relative;

      &-title {
        text-align: center;
        font-size: .2rem;
        color: #333;
        font-weight: 600;
      }

      &-dataRange {
        position: absolute;
        font-size: .12rem;
        left: 0;
      }

      .fullScreen {
        cursor: pointer;
        position: absolute;
        border: 1px dashed rgba(38, 157, 123, 1);
        border-radius: 4px;
        padding: 2px 5px;
        top: 0;
        right: 0;
        font-size: 12px;
        color: #269D7B;
        user-select: none;
      }
    }

    .tip_s {
      font-size: 12px;
      color: #666666;

      .chaeckUserChangeMessage {
        display: inline-block;
        position: relative;
        margin-top: 20px;

        .isDialogShow_c {
          display: none;
          font-size: 14px;
        }

        &:hover {
          .isDialogShow_c {
            display: block;
          }
        }

        ;

      }
    }

    .table_r {
      width: 100%;
      height: calc(100% - 40px);
      overflow: auto;
      position: relative;
      margin-top: 20px;
      transition: all .5s;

      .over {
        background: rgba(125, 125, 125, .1);
      }

      table {
        min-width: 100%;
        border-collapse: collapse;
        border: none;
        font-size: .14rem;

        tr {
          td {
            text-align: center;
            min-width: 80px;
            padding: 8px 10px;
          }

          th {
            padding: 8px 10px;
            white-space: nowrap;
          }
        }

        thead {}

        tbody {
          tr {
            th {
              min-width: 80px;
              width: 180px;
            }
          }
        }
      }
    }

    .table_d {
      height: 100px;
      text-align: center;
      font-size: 20px;
      line-height: 100px;
      color: #999;
      background-color: #fff;
      margin-top: 20px;
    }



  }

  .fullScreenStyle {
    position: fixed;
    top: 0px;
    z-index: 9999;
    left: 0;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
    width: calc(100% - 0px);
    height: calc(100% - 0px);

    .table_r {
      height: calc(100% - 92px);
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/cashier/crossAnalysis.vue